(function () {
  'use strict';

  /* @ngdoc object
   * @name rols
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols', [
      'ui.router',
      'itecAdministracio.rols.main'
    ]);
}());
